/* eslint-disable react/prop-types */
import React from 'react';
import { Fragment } from 'react';

import { createGlobalStyle } from 'styled-components';

export default function Primary() {
  // const [wrap, setWrap] = React.useState(null);

  React.useEffect(() => {
    const btnPrint = document.querySelector('#btn-print');
    btnPrint.addEventListener('click', function () {
      window.print();
    });

    const products = JSON.parse(localStorage.getItem('@products24'));
    if (!products) return false;
    const root = document.getElementById('root');
    root.style.backgroundColor = 'rgb(82, 86, 89)';
    let wrap = document.querySelector('.wrap');
    async function delay(item) {
      const wait = new Promise((resolve) => {
        setTimeout(function () {
          const html = `
                    <div class='container-print'>                        
                      <div class='content'>
                            <figure class='logobg'><img src='/images/bg2.png'/></figure>
                            <p class='avistade'>DE</p>
                            <div class='tab_main tab1'>                                                           
                                <div class='panel'>  
                                    <figure class='dex'><img src='/images/dex.png'/></figure>                             
                                    <div class='panel__description'>
                                        <div class='col1'>
                                            <div class='plano'>20X</div>
                                            <div class='cifrao one'>R$</div>
                                        </div>
                                        <div class='col2 price one'>${String(item.valor24).replace(".","")}<sup class='avista'>,99</sup></div>
                                    </div>
                                </div>                            
                            </div>
                            <p class='avistapor'>POR</p>
                            <div class='tab_main tab2'>                            
                                <div class='panel'>                              
                                    <div class='panel__description'>
                                        <div class='col1'>
                                            <div class='plano'>20X</div>
                                            <div class='cifrao two'>R$</div>
                                        </div>
                                        <div class='col2 price two'>${Math.floor((parseFloat(item.total15x) / 20))}<sup class='avista'>,99</sup></div>
                                    </div>
                                </div>                            
                            </div>

                            <div class='tab_footer'>
                                <div class='panel__info'>
                                    <p class='ref'>REF: ${item.codigo} / ${item.padrao}</p>
                                    <p class='name'>${item.produto}</p>
                                </div>
                                <figure class='prazo'>
                                    <img src=''/>
                                </figure>
                            </div>
                      </div>
                    </div>`;
          wrap.innerHTML += html.trim();
          resolve();
        }, 200);
      });

      return await wait;
    }

    async function processArraySequence(array) {
      let n = 1;
      let count = 1;     
      for (const item of array) {
        await delay(item);
        if (array.length === count) return false;
        if (n === 4) {
          wrap = create();
          n = 0;
        }
        n++;
        count++;
      }
    }

    function create() {
      const wrapAll = document.querySelectorAll('.wrap');
      wrap = wrapAll[wrapAll.length - 1].cloneNode(true);
      wrap.classList.remove('first');
      wrap.innerHTML = "<div class='guia'><div class='guiaY'></div><div class='guiaX'></div></div>";
      root.appendChild(wrap);
      return wrap;
    }

    processArraySequence(products);
  }, []);

  return (
    <Fragment>
      <GlobalStyle />
      <FixedHeader className="fixed-header print" />
      <Wrap className="wrap first" />
    </Fragment>
  );
}

const FixedHeader = ({ className, children }) => (
  <div className={className}>
    <div className="fixed-title">
      <h6>TABELA PRIMÁRIA 2X4</h6>
    </div>
    <div className="buttons">
      <a href="/tabelas/24x">
        <img src="/images/buttons/button-mini-back.svg" alt="Boltão voltar" />
      </a>
      <button id="btn-print">
        <img src="/images/buttons/button-mini-print.svg" alt="Boltão voltar" />
      </button>
    </div>
    {children}
  </div>
);

const Wrap = ({ className, children }) => (
  <Fragment>
    <div className={className}>
      <div className="guia">
        <div className="guiaY"></div>
        <div className="guiaX"></div>
      </div>
    </div>
    {children}
  </Fragment>
);

const GlobalStyle = createGlobalStyle`
* {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
}

body {
    font-family: Helvetica, Arial, sans-serif;
    background-color: rgb(82, 86, 89) !important;
}

img {
    display: block;
    width: 100%;
}



.back {
    background-color: #fff;
    padding: 5px 20px;
    border-radius: 5px;
    text-decoration: none;
    margin-left: 10px;
    font-size: 10pt;
    transform: translate(-35px,-1px);
}
.fixed-header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 15mm;
    background-color: rgb(50, 54, 57);
    box-shadow: 1px 1px 5px #000;
    color: #fff;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    z-index: 10000;
}
.buttons {
    display: flex;
    align-items: center;
}

.fixed-header button {
    transform: all;
    background-color: transparent;
    box-shadow: none;
    border: none
}

.fixed-header button img {
    width: 35px;
}

.fixed-header button img:hover {
    transform-origin: center;
    transform: scale(1.1);
    cursor: pointer;
    transition: all .2s;
}

.buttons a {
    margin: 5px;
}
.buttons a img{
    width: 35px;
}

.fixed-header .wrap-center {
    width: 210mm;
    margin: 0 auto;
}

.wrap{
    position: relative;
    margin: 0 auto;
    width: 210mm;
    height: 297mm;
    color: #444;
    background-color: #fff;
    margin-bottom: 5mm;
}

.wrap.first {
    margin-top: 17mm;
}

.guia {
    position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    z-index: 2;
}

.guia .guiaY {
    position: absolute;
    top: 50%;
    height: 1px;
    width: 100%;
    background-color: rgb(192, 192, 192);
    z-index: 2;
}

.guia .guiaX {
    position: absolute;
    left: 50%;
    height: 100%;
    width: 1px;
    background-color: rgb(192, 192, 192);
    z-index: 2;
}

.container-print {
    position: relative;
    width: calc((210mm - 1px) / 2);
    height: calc((100% - 1px) / 2);
    /* background-color: red; */
    z-index: 1;

    display: flex;
    float: left;
    padding: 20px;

}

.leftimage{
    position: absolute;
    width: 30%;
    right: 22px;
    top: 100px;
    z-index: 1;
}

.righimage{
    position: absolute;
    width: 20%;
    left: 22px;
    top: 350px;
    z-index: 1;
}

.dex {
    position: absolute;
    width: 60%;
    left: 100px;   
    top: 12px;
    z-index: 1;
}

.content {
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    //border: 3px solid #000051;
    border-radius: 10px;
}

.tab_header {
    width: 100%;
}

p.avistade {
    display: flex;   
    width: 100%;
    padding: 0 15px;
    font-size: 18px;
    font-size: 15pt;
    font-family: "Roboto",sans-serif;    
    font-weight: bolder;
    color: #000051;   
    padding: 5px 20px;
    margin-bottom: 10px;
}

p.avistapor {
    display: flex;   
    width: 100%;
    padding: 0 15px;
    font-size: 18px;
    font-size: 15pt;
    font-family: "Roboto",sans-serif;    
    font-weight: bolder;
    color: #000051;   
    padding: 5px 20px;
    margin-bottom: 10px;
}


.tab_header .logo {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 20px;
}

.logobg {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;    
}

.logobg img {
    height: 100%;    
}

.tab_header img {
    width: 90%;
    margin-top: 10px;
}

.tab_main.tab1 {
    position: absolute;
    top: 237px;
    opacity: 0.8;
}

.tab_main.tab2 {
    position: absolute;
    bottom: 52px;
    opacity: 0.8;
}

.tab_main {    
    flex: 1;    
    margin: 0 10px;    
    padding: 2px 10px;
    background-color: white;
    border: 4px solid #015104;
    border-radius: 20px;
    margin-top: -15px;    
    font-family: "Roboto",sans-serif;   
    font-weight: bolder;
    color: #000051;
    z-index: 2;
    width: 320px;
    height: 110px;

}

.tab_main .panel {
    position: relative;
}

.tab_footer {
    position: absolute;
    width: 100%;
    padding: 2px 15px;
    z-index: 1000;
    bottom: 2px;
}

@media only screen and (max-width: 37.5em) {
    .wrap {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        height: 100%;
    }

    .container-print {
        display: flex;
        margin: 0 auto;
        float: none;
    }

    .content {
        transform: scale(1);
        padding: 5rem 0;
    }

    .tab_header img {
        width: 70%;
        transform: translateY(-30%);
    }

    .tab_main {
        margin-bottom: 20px;
    }

    .guia .guiaY,
    .guia .guiaX {
        display: none;
    }
}

.tab_footer .prazo {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
}

.panel.avista {
    padding: 10px 0;
}

.panel.avistade {
    display: flex;   
    width: 100%;
    padding: 0 15px;
    font-size: 18px;
    font-size: 15pt;
    font-family: "Roboto",sans-serif;    
    font-weight: bolder;
    color: #000051;
    margin: 20px 0 0 10px;
    padding: 5px 20px;
}

.panel__info {
    font-family: "Roboto", sans-serif;
    font-size: 10pt;    
    font-weight: bolder;    
    color: #fdfdfd;
}

.panel__info .name {
    
}

.panel__description {
    flex: 1;
    display: flex;
    align-items: center;
    font-family: Impact, 'Courier New', Courier, monospace,Haettenschweiler, 'Arial Narrow Bold', sans-serif;
    
}

.panel__description .col0 {
    display: flex;
    flex-direction: column;    
    color: #000051;    
    width: 20%;
}

.panel__description .col0 .cifrao.first {
    text-align: right;
    font-size: 23pt;
    margin-top: 30px;
}

.panel__description .col1 {
    display: flex;
    flex-direction: column;
    padding-right: 2mm;
    color: #000051;
    //width: 80%;
}


.panel__description .col1 .plano {
    font-size: 30pt;
    color: #014b05;
    border: 4px solid #015104;
    border-radius: 2mm;
    padding: 0 2mm;
    background-color: #fcd502;
}

.panel__description .col1 .cifrao {
    text-align: right;
    //font-size: 23pt;
}

.panel__description .col1 .cifrao.one {
    color: #2a2a9c;
}

.panel__description .col1 .cifrao.two {
    color: #034712;
}

.panel__description .col2 {
    flex: 1;
    font-size: 55pt;
    display: flex;
    justify-content: center;
    line-height: 1;
    color: #2a2a9c;
}

.panel__description .col2.one {
    color: #2a2a9c;
}

.panel__description .col2.two {
    color: #034712;
}

.col2.price {
    //font-size: 68pt;
    margin-top: 15px;
}

.panel__description .col2 sup.avista {
    font-family: Impact, 'Courier New', Courier, monospace,Haettenschweiler, 'Arial Narrow Bold', sans-serif;
    margin: 0;
    margin-top: -8px;
    margin-left: 5px;    
    font-size: 35pt;
}

.panel__description .col2 sup {
    font-family: Impact, 'Courier New', Courier, monospace,Haettenschweiler, 'Arial Narrow Bold', sans-serif;
    height: 20mm;
    font-size: 40pt;
    transform: translateY(3mm);       
}

.panel__footer {
    color: #000051;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 15pt;
    font-family: "Roboto", sans-serif;    
    font-weight: bolder;
}

@page :left {
    margin: 1mm;
}

@page :right {
    margin: 1mm;
}

@page {
    /* size: A4;     */
    size: auto;
    margin: 0;
}

@media print {
    .fixed-header.print {
        display: none;
    }

    .wrap.first {
        margin: 0 !important;
    }

    .wrap{
        position: relative;
        margin: 0 auto;
        width: 210mm;
        height: 297mm;
        color: #444;
        background-color: #fff;
        margin: 0.1mm;
    }

    .container-print {
        position: relative !important;
        width: calc((210mm - 1px) / 2) !important;
        height: calc((100% - 1px) / 2) !important;
        /* background-color: red; */
        z-index: 1;

        display: flex !important;
        float: left !important;
        padding: 20px !important;
    }

    .page-break {
        page-break-before: always;
    }

    .guia .guiaY {

    }

    .guia .guiaX {
        position: absolute;
        left: 50%;
        height: 100%;
        width: 2px;
        background-color: rgb(192, 192, 192);
        z-index: 1000;
    }
}
`;
